export const primaryFont = "'Source Sans Pro', sans-serif"

export const typeScale = {
	h1: "1.8rem",
	h2: "1.6rem",
	h3: "1.4rem",
	h4: "1.2rem",
	h5: "1.1rem",
	p: "1rem",
}

export const fontWeight = {
	bold: 700,
	regular: 400,
}
